
import { defineComponent } from "vue";
import { IParametersModel } from "@/interfaces/modules";
import ParametersService from "@/api/Configuration/ParametersServices";
import store from "@/store";

export default defineComponent({
  name: "ParameterContent",
  data() {
    return {
      form: {
        loading: true,
        dialog: false,
        valid: false,
        record: {} as IParametersModel,
        rules: {
          required: [(v: any) => !!v || "Este campo es requerido"],
        },
      },
      table: {
        filters: { search: "" },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "Code", label: "Código", sortable: true },
          { key: "Name", label: "Nombre", sortable: true },
          { key: "Description", label: "Descripción", sortable: true },
          { key: "Value", label: "Valor", sortable: true },
          { key: "Enable", label: "Activo", sortable: true },
          { key: "CreatedByFormat", label: "Creación", sortable: true },
          { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
          { key: "action", label: "Acciones", sortable: false },
        ],
        records: [] as IParametersModel[],
        rowsPerPage: 10,
      },
    };
  },
  computed: {
    filteredItems(): IParametersModel[] {
      if (!this.table.filters.search) return this.table.records;
      const search = this.table.filters.search.toLowerCase();
      return this.table.records.filter(
        (item) =>
          (item.Name || "").toLowerCase().includes(search) ||
          (item.Description || "").toLowerCase().includes(search)
      );
    },
    rows(): number {
      return this.table.records.length || 0;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.table.loading = true;
      try {
        this.table.records = await ParametersService.GetParameters();
      } finally {
        this.table.loading = false;
      }
    },
    async edit(data: IParametersModel) {
      this.form.record = await ParametersService.GetParametersById(data);
      this.form.dialog = true;
    },
    openModal() {
      // Igual que Identities: sólo inicializamos Enable
      this.form.record = { Enable: true } as IParametersModel;
      this.form.dialog = true;
    },
    async handleSubmit() {
      this.form.dialog = false;
      await ParametersService.PostParameters(this.form.record);
      store.dispatch("core/popupDialog", {
        text: "Registro completado con éxito.",
        type: "success",
        showCancelButton: false,
      });
      this.load();
    },
  },
});
